var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"register"}},[_c('div',{staticClass:"pc"},[(_vm.dialogData.flag)?_c('my_dialogPc',{attrs:{"myDialogData":_vm.dialogData},on:{"handleClick":_vm.handleClick,"focuspassword":_vm.focuspassword,"inputpassword":_vm.inputpassword}}):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }